__turbopack_context__.v({
  "card": "FishSearch-module-scss-module__hdXIQW__card",
  "cardTitle": "FishSearch-module-scss-module__hdXIQW__cardTitle",
  "container": "FishSearch-module-scss-module__hdXIQW__container",
  "formFields": "FishSearch-module-scss-module__hdXIQW__formFields",
  "formRow": "FishSearch-module-scss-module__hdXIQW__formRow",
  "info": "FishSearch-module-scss-module__hdXIQW__info",
  "moreButton": "FishSearch-module-scss-module__hdXIQW__moreButton",
  "section": "FishSearch-module-scss-module__hdXIQW__section",
  "submitButton": "FishSearch-module-scss-module__hdXIQW__submitButton",
  "subtitle": "FishSearch-module-scss-module__hdXIQW__subtitle",
  "title": "FishSearch-module-scss-module__hdXIQW__title",
});
